import React from 'react';
import MakeMobile from "./MakeMobile";
import MakeDesktop from "./MakeDesktop";

export default function MakeWrapper(props) {

    const filter = props.filter;

    const handleSubmit = () => {
        filter.dispatchFilter();
    };

    const forwardProps = {
        handleSubmit: handleSubmit,
    };

    return (
        <>{props.isMobile
            ? <MakeMobile {...forwardProps} filter={filter} classes={props.classes} isMobile={props.isMobile}/>
            : <MakeDesktop {...forwardProps} filter={filter} classes={props.classes} isMobile={props.isMobile}/>
          }</>
    )
}